import { AppScope } from './appScope.types';
import { appScopeFromRouteParams } from './appScopeFromRouteParams';
import { resolveSettingsAppScopeFromPathname } from './resolveSettingsAppScopeFromPathname';

export type ResolveRouteAppScope = (
  params: Record<string, string | undefined>,
  organizationId: string,
  pathname: string
) => AppScope;

export function resolveDualPathAppScope(
  params: Record<string, string | undefined>,
  organizationId: string,
  pathname: string
): AppScope {
  const settingsScope = resolveSettingsAppScopeFromPathname(
    pathname,
    organizationId
  );
  if (settingsScope) {
    return settingsScope;
  }

  if (params.workspaceId != null || params.teamId != null) {
    return appScopeFromRouteParams(params, organizationId);
  }

  return { level: 'organization', organizationId };
}
